import { useObservable } from './rxjs';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
export function useVideoMuted(videoController) {
    const muted = videoController.pipe(switchMap(controller => {
        return controller?.muted ?? of(false);
    }));
    return useObservable(muted);
}
//# sourceMappingURL=use_video_muted.js.map